import { render } from "./password-component.vue?vue&type=template&id=6846fc8a&scoped=true"
import script from "./password-component.vue?vue&type=script&lang=js"
export * from "./password-component.vue?vue&type=script&lang=js"

import "./password-component.vue?vue&type=style&index=0&id=6846fc8a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6846fc8a"]])

export default __exports__